import { SEO } from '@/components/SEO';

export function DPAPage() {
  return (
    <>
      <SEO
        title="Data Processing Agreement - Nestor"
        description="Data Processing Agreement (DPA) for GDPR compliance."
      />

      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Data Processing Agreement (DPA)</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">Last updated: January 24, 2026</p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. Introduction</h2>
            <p>
              This Data Processing Agreement ("DPA") forms part of the Terms of Service between you ("Customer")
              and Nestor ("Processor") and governs the processing of Personal Data.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Definitions</h2>
            <p>Terms used in this DPA shall have the meanings set out in the GDPR:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>"Personal Data" means any information relating to an identified or identifiable natural person</li>
              <li>"Processing" means any operation performed on Personal Data</li>
              <li>"Controller" means the entity that determines the purposes and means of processing</li>
              <li>"Processor" means the entity that processes Personal Data on behalf of the Controller</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. Scope and Roles</h2>
            <p>
              Customer acts as the Controller and Nestor acts as the Processor of Personal Data.
              The Processor shall process Personal Data only on documented instructions from the Controller.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Security Measures</h2>
            <p>The Processor shall implement appropriate technical and organizational measures including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Encryption of Personal Data</li>
              <li>Regular security testing and evaluation</li>
              <li>Access controls and authentication</li>
              <li>Business continuity and disaster recovery</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Sub-Processors</h2>
            <p>
              The Processor may engage sub-processors with prior written consent of the Controller.
              A list of current sub-processors is available upon request.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">6. Data Subject Rights</h2>
            <p>
              The Processor shall assist the Controller in responding to requests from data subjects
              exercising their rights under applicable data protection laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">7. Data Breach Notification</h2>
            <p>
              The Processor shall notify the Controller without undue delay upon becoming aware of
              a Personal Data breach, and no later than 72 hours after detection.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">8. Contact</h2>
            <p>
              For questions regarding this DPA, contact: dpo@hrms.com
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
